import React, { useState } from 'react';
import api from '../services/api';
import { getCmsData } from '../cms/cmsData';
import AnnouncementBar from '../components/AnnouncementBar';
import Footer from '../components/Footer';
import SponsorsSection from '../components/SponsorsSection';
import ScrollToTop from '../components/ScrollToTop';
import TornPaperWrapper from '../components/TornPaperWrapper';
import { trackFormSubmit } from '../utils/ga4';
import { getArabicTranslation } from '../utils/arabicTranslations';
import './Contact.css';
import { getCmsImagePath } from '../cms/cmsData';

const Contact = () => {
  const cms = getCmsData();
  const c = cms.contactPage || {};
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    subject: 'SPONSOR_INQUIRY',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const result = await api.submitContact({
        first_name: formData.firstName,
        last_name: formData.lastName,
        email: formData.email,
        phone: formData.phone,
        subject: formData.subject,
        message: formData.message
      });

      if (result?.success) {
        setSuccess(true);
        trackFormSubmit('contact_form_submit', {
          formName: 'contact_us_form',
          formLocation: 'contact_page',
        });
        setFormData({
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          subject: 'Sponsor Inquiry',
          message: ''
        });
      } else {
        setError(result?.error?.message || 'Failed to send message');
      }
    } catch (err) {
      setError(err.message || 'Failed to send message. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper">
      <AnnouncementBar />
      
      {/* Hero Section with Background */}
      <section className="hero-section">
        <div className="hero-background-wrapper">
          <video src={"/hero-final.mp4"} alt="oc mena festival" className="hero-background-video" autoPlay muted loop playsInline />
          <div className="hero-gradient-overlay"></div>
        </div>

        {/* Torn Paper Card */}
        <TornPaperWrapper>
          <h1 className="card-title">
            {c.title || 'Contact'}
            <span className="arabic-text on-white">{getArabicTranslation(c.title || 'Contact')}</span>
          </h1>
          <p className="card-subtitle">
            <strong>Have questions or want to get involved?</strong><br/>
            For vendor booths, sponsorship opportunities, partnerships, or general inquiries, reach out anytime:
          </p>


          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-group">
              <label htmlFor="firstName">First name <span className="required">*</span></label>
              <input
                type="text"
                id="firstName"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="lastName">Last name</label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email <span className="required">*</span></label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone">Phone</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="subject">Subject <span className="required">*</span></label>
              <select
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
              >
                <option value="SPONSOR_INQUIRY">Sponsor Inquiry</option>
                <option value="VENDOR_INQUIRY">Vendor Inquiry</option>
                <option value="GENERAL_QUESTION">General Question</option>
                <option value="PRESS_INQUIRY">Press Inquiry</option>
                <option value="OTHER">Other</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="5"
              ></textarea>
            </div>

            {error && <div className="error-message" style={{color: '#e74c3c', marginBottom: '1rem', textAlign: 'center'}}>{error}</div>}
            {success && <div className="success-message" style={{color: '#27ae60', marginBottom: '1rem', textAlign: 'center'}}>{c.successMessage || "Thank you! We'll get back to you soon."}</div>}

            <button type="submit" className="btn-primary submit-btn" disabled={loading}>
              {loading ? (c.formLabels?.submitting || 'Sending...') : (c.formLabels?.submit || 'Send Message')}
            </button>
          </form>
        </TornPaperWrapper>

        {/* Lanterns */}
        <div className="lanterns-container">
          <img loading="lazy" src={getCmsImagePath("lanterns", "/lanterns.webp")} alt="festival lanterns" className="lanterns-image" />
        </div>
      </section>

      {/* Sponsors Section */}
      <SponsorsSection />

      {/* Footer */}
      <Footer />
      
      <ScrollToTop />
    </div>
  );
};

export default Contact;
